// Ecomlab homepage behaviour. Loaded by layout/launch.liquid.
(function () {
  var root = document.documentElement;
  var osReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Weak devices get the same lighter mode as visitors who ask for reduced motion: every scene shows its
  // final state, no 3D stage, no scrubbed scenes. Decided in <head> (window.__lxLite) and by the governor below.
  var lite = !osReduced && !!window.__lxLite;
  var reduced = osReduced || lite;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!reduced) root.classList.add('motion');
  var clamp = function (v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var seg = function (p, a, b) { return ease(clamp((p - a) / (b - a))); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // A media query answers from cached state; reading innerWidth mid-frame forced a full layout every call.
  var wideMq = window.matchMedia('(min-width: 900px)');
  // Viewport height, cached: reading it mid-frame forces layout.
  var viewH = window.innerHeight;
  window.addEventListener("resize", function () { viewH = window.innerHeight; }, { passive: true });
  var wide = function () { return wideMq.matches; };
  // Theme assets are plain scripts (Shopify re-minifies JS and rewrites dynamic imports), so load them with a tag.
  function loadScript(src, globalName) {
    return new Promise(function (resolve, reject) {
      if (window[globalName]) return resolve(window[globalName]);
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { window[globalName] ? resolve(window[globalName]) : reject(new Error(globalName + ' missing')); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  var chips = $$('.chip3d');

  /* ---------- headings: words rise out of a mask ---------- */
  $$('[data-words]').forEach(function (el) {
    var i = 0;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (!part.trim()) return frag.appendChild(document.createTextNode(part));
        var m = document.createElement('span');
        m.className = 'wm';
        var w = document.createElement('span');
        w.className = 'w';
        w.style.setProperty('--i', i++);
        w.textContent = part;
        m.appendChild(w);
        frag.appendChild(m);
      });
      node.parentNode.replaceChild(frag, node);
    });
  });

  /* ---------- decoder scramble for small labels ---------- */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*+';
  function scramble(el) {
    if (reduced || el.dataset.scrambled || el.children.length) return;
    el.dataset.scrambled = '1';
    var text = el.textContent;
    var start = performance.now();
    var dur = 650;
    var finish = function () { el.textContent = text; };
    el.setAttribute('aria-label', text);
    (function tick() {
      var k = Math.min(1, (performance.now() - start) / dur);
      if (k >= 1) { finish(); el.removeAttribute('aria-label'); return; }
      el.textContent = text.split('').map(function (ch, i) {
        if (ch === ' ' || i < k * text.length) return ch;
        return GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }).join('');
      requestAnimationFrame(tick);
    })();
    // A throttled or hidden frame loop must never leave a label scrambled.
    setTimeout(function () { finish(); el.removeAttribute('aria-label'); }, dur + 250);
  }


  /* ---------- numbers count up from zero as they come into view ---------- */
  function countUp(el) {
    if (reduced) return;
    var to = parseFloat(el.dataset.count), dec = (el.dataset.count.split('.')[1] || '').length;
    var pre = el.dataset.pre || '', suf = el.dataset.suf || '', final = el.textContent, start = null;
    (function tick(now) {
      if (start === null) start = now;
      var k = clamp((now - start) / 1300);
      el.textContent = pre + (to * (1 - Math.pow(1 - k, 3))).toFixed(dec) + suf;
      if (k < 1) requestAnimationFrame(tick); else el.textContent = final;
    })(performance.now());
    // A throttled frame loop must never leave a half-counted number.
    setTimeout(function () { el.textContent = final; }, 1700);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.classList.contains('eyebrow')) scramble(e.target);
      $$('[data-count]', e.target).forEach(countUp);
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  $$('[data-reveal], [data-words], .eyebrow').forEach(function (el) {
    if (el.closest('.lx-hero')) setTimeout(function () { el.classList.add('is-in'); }, 150);
    else io.observe(el);
  });
  $$('.lx-hero .giant--2').forEach(function (el) { el.style.setProperty('--d', '0.25s'); });
  setTimeout(function () { $$('.lx-hero .mono').forEach(scramble); }, 1300);

  /* ---------- story: words light up as you read ---------- */
  var lits = $$('[data-light]').map(function (el) {
    var hl = (el.dataset.hl || '').toLowerCase().split(/\s+/);
    // Build the word spans as text nodes: re-parsing textContent as HTML would turn any tag-like text into markup.
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'w' + (hl.indexOf(w.toLowerCase()) > -1 ? ' w--hl' : '');
      s.textContent = w;
      if (i) el.appendChild(document.createTextNode(' '));
      el.appendChild(s);
    });
    return { el: el, words: $$('.w', el) };
  });

  /* ---------- self-check ---------- */
  var response = $('.check__response');
  $$('.check__list button').forEach(function (b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      var n = $$('.check__list [aria-pressed="true"]').length;
      response.textContent = n === 0 ? '' : n === 1 ? response.dataset.one : response.dataset.many;
    });
  });

  /* ---------- try it ---------- */
  var mini = $('#mini');
  $$('.try input').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.name === 'c') mini.style.setProperty('--brand', input.value);
      else mini.dataset.f = input.value;
    });
  });

  /* ---------- pointer effects (desktop) ---------- */
  var cursor = $('.cursor');
  var cursorLabel = $('.cursor__label');
  var pointer = { x: -100, y: -100, cx: -100, cy: -100, nx: 0, ny: 0 };
  if (fine && !reduced) {
    root.classList.add('has-cursor');
    window.addEventListener('pointermove', function (e) {
      pointer.x = e.clientX;
      pointer.y = e.clientY;
      pointer.nx = e.clientX / window.innerWidth - 0.5;
      pointer.ny = e.clientY / window.innerHeight - 0.5;
      var t = e.target.closest && e.target.closest('[data-cursor]');
      var label = t ? t.dataset.cursor : '';
      cursorLabel.textContent = label;
      cursor.classList.toggle('is-label', !!label && label !== 'X-ray');
      cursor.classList.toggle('is-xray', label === 'X-ray');
    }, { passive: true });
    document.addEventListener('pointerleave', function () { pointer.x = pointer.y = -100; });
    (function follow() {
      pointer.cx += (pointer.x - pointer.cx) * 0.2;
      pointer.cy += (pointer.y - pointer.cy) * 0.2;
      cursor.style.transform = 'translate3d(' + pointer.cx + 'px,' + pointer.cy + 'px,0)';
      chips.forEach(function (c) {
        var z = Number(c.style.getPropertyValue('--z'));
        c.style.setProperty('--px', (pointer.nx * z * -46).toFixed(1) + 'px');
        c.style.setProperty('--py', (pointer.ny * z * -30).toFixed(1) + 'px');
      });
      requestAnimationFrame(follow);
    })();

    $$('.magnetic').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.25 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.35 + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });

    $$('[data-tilt]').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--tx', ((x - 0.5) * 12).toFixed(2) + 'deg');
        card.style.setProperty('--ty', ((0.5 - y) * 10).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
        card.style.setProperty('--go', '1');
      });
      card.addEventListener('pointerleave', function () {
        ['--tx', '--ty'].forEach(function (p) { card.style.setProperty(p, '0deg'); });
        card.style.setProperty('--go', '0');
      });
    });
  }

  /* ---------- 3D stage ---------- */
  var stageHost = $('#stage');
  var stage = null;
  var hero = $('.lx-hero');
  /* ---------- hero: same ad, same budget ----------
     Run 1 sends a fixed batch of paid clicks into the basic store. Run 2 sends the exact same
     clicks, at the exact same cost each, into the store rebuilt with Ecomlab. The ledger
     counts both side by side. Seeded, so every visitor sees the same illustration. */
  var hero = $('.lx-hero');
  var heroSlot = $('#hero-slot');
  var flowCanvas = $('#flow');
  var fctx = flowCanvas.getContext('2d');
  var adCta = $('#ad-cta');
  var heroOrders = $('#orders');
  var phaseEl = $('#phase');
  var phaseT = $('#phase-t');
  var ledger = $('#ledger');
  var replayBtn = $('#ledger-replay');
  var CLICKS = 36;
  var flow = { parts: [], acc: 0, last: 0, screen: null, tap: null, brand: 0, visible: true, dpr: 1, lastOrder: 0 };
  var run = { phase: 'idle', col: 'b', sent: 0, done: 0, rand: null, timer: 0, plan: [] };
  var PLANS = {
    b: { L: 29, CA: 5, O: 2 },
    a: { L: 9, B: 14, BCA: 4, BO: 2, CA: 5, O: 2 }
  };
  function makePlan(col, rand) {
    var list = [];
    Object.keys(PLANS[col]).forEach(function (k) { for (var i = 0; i < PLANS[col][k]; i++) list.push(k); });
    for (var j = list.length - 1; j > 0; j--) { var r = Math.floor(rand() * (j + 1)); var t = list[j]; list[j] = list[r]; list[r] = t; }
    return list;
  }
  var tally = {};

  function seeded(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6d2b79f5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  /* The scorecard spends the visitor's own monthly ad budget on both stores. The particles are a
     sample of that traffic; the rates are the illustration's fixed outcome, so it ends the same way. */
  var AOV = 999;
  var CPC = 12;
  var BUDGETS = [3000, 5000, 10000, 15000, 25000, 50000, 75000, 100000, 200000];
  var MODEL = {
    b: { bounce: 0.78, atc: 0.042, cr: 0.011 },
    a: { bounce: 0.46, atc: 0.091, cr: 0.023 }
  };
  var cells = {};
  $$('td[data-k]', ledger).forEach(function (td) { cells[td.dataset.c + td.dataset.k] = td; });
  var deltas = {};
  $$('[data-delta]', ledger).forEach(function (el) { deltas[el.dataset.delta] = el; });
  var budgetInput = $('#budget');
  var budgetOut = $('#budget-v');
  var spentEl = $('#spent');
  var spentOf = $('#spent-of');
  var verdict = $('#verdict');
  var budgetChips = $$('.budget__chips button');
  var jitter = seeded(5);
  function budget() { return BUDGETS[+budgetInput.value] || 10000; }
  function rupees(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function pct(n) { return (n * 100).toFixed(1) + '%'; }
  function ordersFor(col) { return Math.max(1, Math.round((budget() / CPC) * MODEL[col].cr)); }
  function metrics(col) {
    var t = tally[col];
    var m = MODEL[col];
    var clicks = Math.round((budget() / CPC) * t.sent / CLICKS);
    var q = t.done / CLICKS;
    var done = q >= 1;
    var wobble = function (v) { return done ? v : v * (1 + (jitter() - 0.5) * 0.12 * (1 - q)); };
    var live = q * 1000 >= 60;
    var orders = done ? ordersFor(col) : Math.floor(ordersFor(col) * q);
    var spend = done ? budget() : clicks * CPC;
    var cr = live ? wobble(m.cr) : null;
    return {
      spend: spend,
      clicks: clicks,
      bounce: live ? wobble(m.bounce) : null,
      atc: live ? wobble(m.atc) : null,
      cr: cr,
      orders: orders,
      sales: orders * AOV,
      cpp: done ? budget() / orders : (cr ? CPC / cr : null),
      roas: done ? (orders * AOV) / budget() : (cr ? (cr * AOV) / CPC : null)
    };
  }
  function show(td, text) {
    if (td.textContent === text) return;
    td.textContent = text;
    // Replay the bump without reading layout: the old class toggle + offsetWidth forced a full
    // page layout for every cell, every time the running ledger ticked.
    if (reduced || !td.animate) return;
    td.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)', offset: 0.4 }, { transform: 'scale(1)' }], { duration: 400, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
  }
  function paintRow(col) {
    var v = metrics(col);
    var dash = '—';
    show(cells[col + 'clicks'], v.clicks.toLocaleString('en-IN'));
    show(cells[col + 'bounce'], v.bounce === null ? dash : pct(v.bounce));
    show(cells[col + 'atc'], v.atc === null ? dash : pct(v.atc));
    show(cells[col + 'cr'], v.cr === null ? dash : pct(v.cr));
    show(cells[col + 'orders'], String(v.orders));
    show(cells[col + 'sales'], rupees(v.sales));
    show(cells[col + 'cpp'], v.cpp === null ? dash : rupees(v.cpp));
    show(cells[col + 'roas'], v.roas === null ? dash : v.roas.toFixed(2) + '×');
    cells[col + 'roas'].classList.toggle('is-loss', v.roas !== null && v.roas < 1);
    if (run.col === col) spentEl.textContent = rupees(v.spend);
    return v;
  }
  function paintVerdict() {
    var B = rupees(budget());
    var ob = ordersFor('b'), oa = ordersFor('a');
    if (tally.a.done >= CLICKS) {
      var loss = budget() - ob * AOV;
      verdict.innerHTML = 'Same <b>' + B + '</b> ad spend. Basic store: <b class="v-bad">' + ob + ' orders</b>' +
        (loss > 0 ? ', ' + rupees(loss) + ' short of the ad bill' : '') +
        '. Ecomlab: <b class="v-good">' + oa + ' orders</b>. That’s <b class="v-gold">+' + (oa - ob) + ' orders and +' + rupees((oa - ob) * AOV) + ' in sales</b> from the same budget.';
      verdict.classList.add('is-final');
    } else if (run.col === 'a' || run.phase === 'switch') {
      verdict.innerHTML = 'Now the <b>same ' + B + '</b> goes to an Ecomlab store…';
      verdict.classList.remove('is-final');
    } else {
      verdict.innerHTML = 'Spending <b>' + B + '</b> on ads that send people to a basic store…';
      verdict.classList.remove('is-final');
    }
  }
  function paintDeltas() {
    var ready = tally.a.done >= CLICKS && tally.b.done >= CLICKS;
    var b = metrics('b'), a = metrics('a');
    deltas.cpp.textContent = ready ? '−' + Math.round((1 - a.cpp / b.cpp) * 100) + '%' : '—';
    deltas.cr.textContent = ready ? (a.cr / b.cr).toFixed(1) + '×' : '—';
    deltas.roas.textContent = ready ? (a.roas / b.roas).toFixed(1) + '×' : '—';
    ledger.classList.toggle('has-impact', ready);
    paintVerdict();
  }
  function refresh(col) {
    paintRow(col);
    paintDeltas();
  }
  function setBudget(i) {
    budgetInput.value = i;
    var B = budget();
    budgetOut.textContent = rupees(B);
    spentOf.textContent = rupees(B);
    budgetChips.forEach(function (c) { c.setAttribute('aria-pressed', String(+c.dataset.b === B)); });
    budgetOut.classList.remove('is-bump');
    void budgetOut.offsetWidth;
    budgetOut.classList.add('is-bump');
    ['b', 'a'].forEach(function (c) { if (tally[c].sent) paintRow(c); });
    if (run.phase === 'done' || reduced) spentEl.textContent = rupees(B);
    paintDeltas();
    if (leakEls.month.length || leakEls.day.length) { paintLeakStatic(); paintLeak(); }
  }
  budgetInput.addEventListener('input', function () { setBudget(+budgetInput.value); });
  budgetChips.forEach(function (c) {
    c.addEventListener('click', function () { setBudget(BUDGETS.indexOf(+c.dataset.b)); });
  });
  /* The cost of waiting: sales a basic store misses at the visitor's budget, counted from the
     first of this month and still ticking. Loss aversion in place of a countdown. */
  var leakEls = {
    month: $$('[data-leak-month]'), budget: $$('[data-leak-budget]'),
    day: $$('[data-leak-day]'), payback: $$('[data-leak-payback]'), short: $$('[data-leak-short]')
  };
  var kitPrice = (function () {
    var el = $('.dock__price [data-lx-price]') || $('.dock__price') || $('.nav__buy b');
    var was = el && $('.cpn-was', el);
    if (was) el = { textContent: el.textContent.replace(was.textContent, '') };
    var n = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : 299;
    return n || 299;
  })();
  function leakPerDay() { return ((ordersFor('a') - ordersFor('b')) * AOV) / 30; }
  function setAll(list, text) { list.forEach(function (el) { if (el.textContent !== text) el.textContent = text; }); }
  function paintLeakStatic() {
    var perDay = leakPerDay();
    var hours = kitPrice / (perDay / 24);
    setAll(leakEls.budget, rupees(budget()));
    setAll(leakEls.day, rupees(perDay));
    setAll(leakEls.payback, hours < 36 ? 'about ' + Math.max(1, Math.round(hours)) + ' hours' : 'about ' + Math.round(hours / 24) + ' days');
    setAll(leakEls.short, hours < 36 ? Math.max(1, Math.round(hours)) + ' hrs' : Math.round(hours / 24) + ' days');
  }
  function paintLeak() {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var days = (now - start) / 86400000;
    var v = leakPerDay() * days;
    var text = '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // Only the copies on screen tick; each text change re-lays out its card.
    setAll(leakEls.month.filter(function (el) { return !el.closest('.is-idle'); }), text);
  }
  if (leakEls.month.length || leakEls.day.length) {
    paintLeakStatic();
    paintLeak();
    setInterval(paintLeak, reduced ? 60000 : 250);
  }

  /* ---------- launch coupon: applied by default; Remove shows the full price everywhere ---------- */
  (function () {
    var boxes = $$('[data-cpn]');
    if (!boxes.length) return;
    var d = boxes[0].dataset;
    var code = (function () {
      var a = $('a[href*="discount="]');
      var m = a && a.getAttribute('href').match(/[?&]discount=([^&]+)/);
      return m ? m[1] : '';
    })();
    function setApplied(on) {
      $$('[data-lx-price]').forEach(function (el) { el.textContent = on ? d.sale : d.full; });
      $$('[data-cpn-was], [data-cpn-badge]').forEach(function (el) { el.hidden = !on; });
      boxes.forEach(function (b) {
        $('.cpn__on', b).hidden = !on;
        $('.cpn__off', b).hidden = on;
        b.classList.toggle('is-removed', !on);
      });
      // Buy links ALWAYS carry the code, even after Remove: checkout opens at the launch price whatever the page
      // shows, and it survives in-app browsers that drop the background discount cookie.
      $$('a[href*="/cart/"]').forEach(function (a) {
        var href = a.getAttribute('href').replace(/[?&]discount=[^&]*/, '');
        if (code) href += (href.indexOf('?') > -1 ? '&' : '?') + 'discount=' + code;
        a.setAttribute('href', href);
      });
      if (window.lxApplyCoupon) window.lxApplyCoupon();
      kitPrice = parseFloat(on ? d.saleN : d.fullN) || kitPrice;
      window.lxPayPrice = kitPrice;
      paintLeakStatic();
      window.dispatchEvent(new CustomEvent('lx:price'));
    }
    boxes.forEach(function (b) {
      $('[data-cpn-remove]', b).addEventListener('click', function () {
        setApplied(false);
        var again = $('[data-cpn-apply]', b);
        if (again) again.focus();
      });
      $('[data-cpn-apply]', b).addEventListener('click', function () {
        setApplied(true);
        $('[data-cpn-remove]', b).focus();
      });
    });
    window.lxPayPrice = parseFloat(d.saleN) || kitPrice;
  })();

  function resetTally() {
    ['b', 'a'].forEach(function (c) {
      tally[c] = { sent: 0, done: 0 };
      paintRow(c);
    });
    spentEl.textContent = rupees(0);
    paintDeltas();
  }
  function markLive(col) {
    $$('td', ledger).forEach(function (td) { td.classList.toggle('is-live', td.dataset.c === col); });
  }
  function setPhase(name, text) {
    run.phase = name;
    phaseEl.className = 'phase is-' + name;
    phaseT.textContent = text;
    paintVerdict();
  }

  /* Orders */
  var PRODUCTS = ['Oversized Tee · ₹799', 'Canvas tote · ₹599', 'Oversized Tee × 2 · ₹1,598', 'Twill cap · ₹549', 'Studio mug · ₹449'];
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8Zm3 0V6a3 3 0 0 1 6 0v2" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var orderN = 0;
  function addOrder(list, label, keep) {
    keep = keep || 3;
    var el = document.createElement('div');
    el.className = 'order';
    el.innerHTML = '<span class="order__ico">' + BAG + '</span><div><b>New order</b><span>' + (label || PRODUCTS[orderN++ % PRODUCTS.length]) + '</span></div><time>now</time>';
    list.prepend(el);
    var items = list.children;
    for (var i = keep; i < items.length; i++) {
      (function (old) {
        old.classList.add('is-out');
        setTimeout(function () { old.remove(); }, 500);
      })(items[i]);
    }
  }

  /* Particles */
  function sprite(rgb) {
    var c = document.createElement('canvas');
    c.width = c.height = 32;
    var g = c.getContext('2d');
    var gr = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    gr.addColorStop(0, 'rgba(255,255,255,1)');
    gr.addColorStop(0.25, 'rgba(' + rgb + ',0.95)');
    gr.addColorStop(1, 'rgba(' + rgb + ',0)');
    g.fillStyle = gr;
    g.fillRect(0, 0, 32, 32);
    return c;
  }
  var SPR = { click: sprite('155,140,255'), leak: sprite('255,96,96'), gold: sprite('255,181,71'), browse: sprite('127,240,189'), fade: sprite('163,166,177') };
  var COL = { click: 'rgba(155,140,255,', leak: 'rgba(255,96,96,', gold: 'rgba(255,181,71,', browse: 'rgba(127,240,189,', fade: 'rgba(163,166,177,' };

  function sizeFlow() {
    var r = flowCanvas.getBoundingClientRect();
    flow.dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(r.width * flow.dpr)), h = Math.max(1, Math.round(r.height * flow.dpr));
    // Phones fire resize as the address bar slides; reallocating an unchanged canvas just stutters.
    if (w === flowCanvas.width && h === flowCanvas.height) return;
    flowCanvas.width = w;
    flowCanvas.height = h;
  }
  sizeFlow();
  window.addEventListener('resize', sizeFlow);
  function rectCenter(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function screenBox() {
    if (flow.screen && flow.screen.x1 > flow.screen.x0) return flow.screen;
    var r = heroSlot.getBoundingClientRect();
    return { x0: r.left + r.width * 0.08, x1: r.right - r.width * 0.08, y0: r.top + r.height * 0.04, y1: r.bottom - r.height * 0.04 };
  }
  function inScreen(fx, fy) {
    var b = screenBox();
    return { x: b.x0 + (b.x1 - b.x0) * fx, y: b.y0 + (b.y1 - b.y0) * fy };
  }
  function bez(a, c, b, t) { var u = 1 - t; return u * u * a + 2 * u * t * c + t * t * b; }
  function go(p, ph, to, dur, lift) {
    p.ph = ph; p.t = 0; p.dur = dur;
    p.x0 = p.x; p.y0 = p.y; p.x1 = to.x; p.y1 = to.y;
    p.cx = (p.x + to.x) / 2; p.cy = (p.y + to.y) / 2 - (lift || 0);
  }

  function spawn() {
    var col = run.col;
    run.sent++;
    tally[col].sent++;
    refresh(col);
    var s = rectCenter(adCta);
    var to = inScreen(0.2 + run.rand() * 0.6, 0.12 + run.rand() * 0.5);
    var p = { k: 'click', col: col, x: s.x, y: s.y, trail: [], plan: run.plan[run.sent - 1], hops: 0 };
    go(p, 'fly', to, 0.8 + run.rand() * 0.4, 70 + run.rand() * 90);
    flow.parts.push(p);
    adCta.classList.add('is-hit');
    setTimeout(function () { adCta.classList.remove('is-hit'); }, 140);
  }

  // What a visitor does once they land, from the run's fixed plan.
  function decide(p) {
    var plan = p.plan;
    if (plan === 'L') return leave(p, true);
    if (plan.charAt(0) === 'B') return browse(p);
    return toCart(p, plan === 'O');
  }
  function leave(p, fast) {
    p.k = fast ? 'leak' : 'fade';
    p.ph = 'leave';
    p.vx = (run.rand() - 0.5) * 200;
    p.vy = fast ? -40 - run.rand() * 90 : -10;
    p.life = fast ? 1.4 : 1.1;
  }
  function browse(p) {
    p.k = 'browse';
    p.hops = 3;
    go(p, 'browse', inScreen(0.15 + run.rand() * 0.7, 0.15 + run.rand() * 0.6), 0.55, 0);
  }
  function toCart(p, buys) {
    p.k = 'gold';
    p.buys = buys;
    var tap = flow.tap || rectCenter(heroSlot);
    go(p, 'cart', tap, 0.45, 20);
  }
  function arrive(p) {
    if (p.ph === 'fly') return decide(p);
    if (p.ph === 'browse') {
      p.hops--;
      if (p.hops > 0) return go(p, 'browse', inScreen(0.15 + run.rand() * 0.7, 0.15 + run.rand() * 0.6), 0.5 + run.rand() * 0.3, 0);
      if (p.plan === 'B') return leave(p, false);
      return toCart(p, p.plan === 'BO');
    }
    if (p.ph === 'cart') {
      if (!p.buys) { p.k = 'fade'; return leave(p, false); }
      var o = heroOrders.getBoundingClientRect();
      return go(p, 'order', { x: o.left + 30, y: o.top + 22 }, 0.7, 70);
    }
    if (p.ph === 'order') {
      addOrder(heroOrders, null, 2);
      if (p.col === 'a' && stage && stage.ping) stage.ping();
      if (p.col === 'a' && fb.screens) fb.screens.ping();
      p.ph = 'gone';
    }
  }

  function settle() {
    run.done++;
    tally[run.col].done = run.done;
    refresh(run.col);
    if (run.done < CLICKS || run.sent < CLICKS) return;
    if (run.col === 'b') {
      setPhase('switch', 'Publishing Ecomlab…');
      publish(function () {
        setPhase('switch', 'Same ad. Same budget. Now with Ecomlab.');
        if (stage) stage.setBrand(true);
        else flow.brand = 1;
        hero.classList.add('is-rebuilt');
        run.timer = setTimeout(function () { startRun('a'); }, 1500);
      });
    } else {
      setPhase('done', 'Same ad spend. A different store.');
      ledger.classList.add('is-done');
      replayBtn.classList.add('is-ready');
      markLive('');
    }
  }

  function startRun(col) {
    run.col = col;
    run.sent = 0;
    run.done = 0;
    run.acc = 0;
    run.rand = seeded(col === 'b' ? 11 : 23);
    run.plan = makePlan(col, run.rand);
    markLive(col);
    if (col === 'b') setPhase('before', 'Before · Basic store');
    else setPhase('after', 'After · Ecomlab');
    spentEl.textContent = rupees(0);
    paintVerdict();
  }

  /* Shopify admin: the theme gets published, then the store in the phone changes. */
  var pub = $('#publish');
  var pubTimers = [];
  function placePublish() {
    var b = screenBox();
    pub.style.left = (b.x0 + b.x1) / 2 + 'px';
    pub.style.top = b.y0 + (b.y1 - b.y0) * 0.42 + 'px';
  }
  function publish(done) {
    pubTimers.forEach(clearTimeout);
    placePublish();
    pub.className = 'publish is-on';
    pubTimers = [
      setTimeout(function () { pub.classList.add('is-press'); }, 750),
      setTimeout(function () { pub.classList.add('is-loading'); }, 950),
      setTimeout(function () { pub.classList.add('is-done'); }, 1900),
      setTimeout(function () { done(); }, 2150),
      setTimeout(function () { pub.classList.add('is-out'); }, 2700),
      setTimeout(function () { pub.className = 'publish'; }, 3300)
    ];
  }

  function replay() {
    clearTimeout(run.timer);
    pubTimers.forEach(clearTimeout);
    pub.className = 'publish';
    flow.parts.length = 0;
    resetTally();
    ledger.classList.remove('is-done');
    replayBtn.classList.remove('is-ready');
    hero.classList.remove('is-rebuilt');
    if (stage) { stage.setBrand(false); if (stage.resetStore) stage.resetStore(); }
    flow.brand = 0;
    startRun('b');
  }
  replayBtn.addEventListener('click', replay);

  function stepFlow(now) {
    if (!flow.visible || reduced) { flow.last = 0; return; }
    var dt = flow.last ? Math.min((now - flow.last) / 1000, 0.05) : 1 / 60;
    flow.last = now;
    if ((run.phase === 'before' || run.phase === 'after') && run.sent < CLICKS) {
      run.acc += dt * 4.6;
      while (run.acc > 1 && run.sent < CLICKS) { run.acc -= 1; spawn(); }
    }

    var cr = flowCanvas.getBoundingClientRect();
    var d = flow.dpr;
    fctx.setTransform(d, 0, 0, d, 0, 0);
    fctx.clearRect(0, 0, cr.width, cr.height);
    fctx.globalCompositeOperation = 'lighter';

    for (var i = flow.parts.length - 1; i >= 0; i--) {
      var p = flow.parts[i];
      if (p.ph === 'leave') {
        p.vy += (p.k === 'leak' ? 760 : 120) * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.life -= dt;
        if (p.life <= 0) { flow.parts.splice(i, 1); settle(); continue; }
      } else if (p.ph === 'gone') {
        flow.parts.splice(i, 1);
        settle();
        continue;
      } else {
        p.t += dt / p.dur;
        var t = Math.min(p.t, 1);
        var e = p.ph === 'fly' ? t : 1 - Math.pow(1 - t, 3);
        p.x = bez(p.x0, p.cx, p.x1, e);
        p.y = bez(p.y0, p.cy, p.y1, e);
        if (p.t >= 1) arrive(p);
      }
      p.trail.push(p.x, p.y);
      if (p.trail.length > 16) p.trail.splice(0, 2);
      var alpha = p.ph === 'leave' ? Math.max(0, p.life / 1.4) : 1;
      var col = COL[p.k];
      fctx.lineWidth = p.k === 'gold' ? 2.4 : 1.6;
      fctx.lineCap = 'round';
      for (var j = 2; j < p.trail.length; j += 2) {
        fctx.strokeStyle = col + (alpha * (j / p.trail.length) * 0.7).toFixed(3) + ')';
        fctx.beginPath();
        fctx.moveTo(p.trail[j - 2] - cr.left, p.trail[j - 1] - cr.top);
        fctx.lineTo(p.trail[j] - cr.left, p.trail[j + 1] - cr.top);
        fctx.stroke();
      }
      var size = p.k === 'gold' ? 22 : 16;
      fctx.globalAlpha = alpha;
      fctx.drawImage(SPR[p.k], p.x - cr.left - size / 2, p.y - cr.top - size / 2, size, size);
      fctx.globalAlpha = 1;
    }
    requestAnimationFrame(stepFlow);
  }
  // The run plays while the hero or the scorecard is on screen. Reaching the scorecard after the
  // run has finished replays it once, so the numbers are seen counting.
  var moneySec = $('#money');
  var seenFlow = { hero: false, money: false };
  var replayedOnArrival = false;
  var flowIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { seenFlow[e.target === hero ? 'hero' : 'money'] = e.isIntersecting; });
    var was = flow.visible;
    flow.visible = seenFlow.hero || seenFlow.money;
    if (flow.visible && !was) requestAnimationFrame(stepFlow);
    if (seenFlow.money && !replayedOnArrival && run.phase === 'done' && !reduced) {
      replayedOnArrival = true;
      replay();
    }
  }, { threshold: 0.25 });
  flowIO.observe(hero);
  if (moneySec) flowIO.observe(moneySec);

  resetTally();
  if (reduced) {
    // Show the finished comparison without motion.
    ['b', 'a'].forEach(function (c) {
      tally[c] = { sent: CLICKS, done: CLICKS };
      paintRow(c);
    });
    paintDeltas();
    ledger.classList.add('is-done');
    setPhase('done', 'Same ad. Same budget. A different store.');
  } else {
    setTimeout(function () { startRun('b'); requestAnimationFrame(stepFlow); }, 1400);
  }

  var lines = $('#rebuild-lines');
  var callouts = $$('.callout');
  var tapEl = $('#tap');
  var toast = $('#cart-toast');
  var paths = callouts.map(function () {
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('r', '4');
    lines.appendChild(p);
    lines.appendChild(c);
    return { p: p, c: c };
  });

  var rebuildSticky = null;
  function onFrame(info) {
    if (info.mode === 'hero') {
      flow.screen = info.screen;
      flow.tap = info.tap;
    }
    if (info.mode !== 'rebuild') {
      tapEl.classList.remove('is-on');
      toast.classList.remove('is-on');
      return;
    }
    var sticky = (rebuildSticky || (rebuildSticky = $('.rebuild__sticky'))).getBoundingClientRect();
    // The finger taps the rebuilt buy button and the cart confirms (fixed layer above the 3D canvas).
    var inView = sticky.top <= 1 && sticky.bottom >= viewH - 1;
    tapEl.classList.toggle('is-on', inView && info.rebuild > 0.9);
    tapEl.style.transform = 'translate(' + info.tap.x + 'px,' + info.tap.y + 'px)';
    toast.classList.toggle('is-on', inView && info.rebuild > 0.93);
    toast.style.left = info.tap.x + 'px';
    toast.style.top = info.tap.y + (wide() ? 64 : 48) + 'px';
    if (!wide()) return;
    info.anchors.forEach(function (a, i) {
      var el = callouts[i];
      var on = el.classList.contains('is-on');
      var y = clamp(a.y - sticky.top, 170, sticky.height - 60);
      el.style.top = y - 20 + 'px';
      var r = el.getBoundingClientRect();
      var x0 = r.left - sticky.left - 8, y0 = r.top + r.height / 2 - sticky.top;
      var x1 = a.x - sticky.left, y1 = a.y - sticky.top;
      var mx = x0 + (x1 - x0) * 0.55;
      paths[i].p.setAttribute('d', 'M' + x0 + ' ' + y0 + ' L' + mx + ' ' + y0 + ' L' + x1 + ' ' + y1);
      paths[i].p.style.opacity = on ? 1 : 0;
      paths[i].c.setAttribute('cx', x1);
      paths[i].c.setAttribute('cy', y1);
      paths[i].c.style.opacity = on ? 1 : 0;
      var fixed = el.classList.contains('is-fixed');
      paths[i].p.classList.toggle('is-fixed', fixed);
      paths[i].c.classList.toggle('is-fixed', fixed);
    });
  }

  function capable() {
    if (reduced) return false;
    var nav = navigator;
    if (nav.connection && nav.connection.saveData) return false;
    if (nav.deviceMemory && nav.deviceMemory < 4) return false;
    try {
      var c = document.createElement('canvas');
      return !!(c.getContext('webgl2') || c.getContext('webgl'));
    } catch (e) { return false; }
  }

  if (capable()) {
    loadScript(document.body.dataset.lxStage, 'LaunchStage').then(function (m) {
      return m.mount(stageHost, {
        heroSlot: heroSlot,
        rebuildSlot: $('#rebuild-slot'),
        rebuildSection: $('#rebuild'),
        finalSlot: $('#final-slot'),
        finalSection: $('#final'),
        onFrame: onFrame,
        strings: {}
      });
    }).then(function (s) {
      stage = s;
      root.classList.add('has-3d');
      update();
    }).catch(function (e) { console.error('stage', e); startFallback(); });
  }
  /* Without WebGL (old phones, data saver, low memory, reduced motion) or if the 3D phone gives up
     mid-scroll, a flat phone shows the same two live stores in every slot. */
  var fb = { on: false, screens: null, last: 0, t0: performance.now() };
  var fbList = $$('.fphone canvas').map(function (c) { return { c: c, slot: c.parentNode.parentNode, shown: '' }; });
  function fbWhich(slot) {
    if (slot.id === 'hero-slot') return hero.classList.contains('is-rebuilt') ? 'brand' : 'basic';
    if (slot.id === 'rebuild-slot') return parseFloat(rebuild.style.getPropertyValue('--brand') || 0) > 0.5 ? 'brand' : 'basic';
    return 'brand';
  }
  function fbDraw(now) {
    if (!fb.screens) return;
    var H = viewH;
    var due = now - fb.last > (reduced ? 0 : 50);
    if (due) {
      var dt = (now - fb.last) / 1000;
      fb.last = now;
      fb.screens.tick(Math.min(dt, 0.1));
      fbList.forEach(function (f) {
        var r = f.c.getBoundingClientRect();
        if (r.bottom < 0 || r.top > H || !r.width) return;
        var which = fbWhich(f.slot);
        if (reduced && f.shown === which) return;
        if (f.shown && f.shown !== which) {
          f.c.parentNode.classList.remove('is-swap');
          void f.c.offsetWidth;
          f.c.parentNode.classList.add('is-swap');
        }
        f.shown = which;
        f.c.getContext('2d').drawImage(fb.screens.compose(which, (now - fb.t0) / 1000, reduced), 0, 0);
      });
    }
    requestAnimationFrame(fbDraw);
  }
  function startFallback() {
    if (fb.on) return;
    fb.on = true;
    stage = null;
    root.classList.remove('has-3d');
    root.classList.add('no-3d');
    loadScript(document.body.dataset.lxScreens, 'LaunchScreens').then(function (m) {
      return m.liveScreens({});
    }).then(function (s) {
      fb.screens = s;
      requestAnimationFrame(fbDraw);
    }).catch(function (e) { console.error('screens', e); });
  }
  stageHost.addEventListener('ls:rebuild-fallback', startFallback);
  if (!capable()) startFallback();

  if (!reduced) loadScript(document.body.dataset.lxSmooth, 'LaunchSmooth').then(function (m) { m.start(); }).catch(function () {});

  /* ---------- Store Lab: build your own storefront ---------- */
  (function lab() {
    var section = $('#try');
    if (!section) return;
    var phone = $('#lab-phone');
    var tilt = $('#lab-tilt');
    var ghost = $('#lab-ghost');
    var NICHES = {
      tee: { label: 'Tee', ghost: 'Streetwear', name: 'Oversized Tee', price: 799, compare: 1299, tag: 'New drop', variants: ['S', 'M', 'L', 'XL'], announce: 'Free delivery on prepaid orders  ✦  7-day returns  ✦  COD available', review: '"Exactly like the photos. Fits perfectly."', colour: '#9B8CFF',
        icon: 'M30 20l12-6q8 6 16 0l12 6 14 14-10 10-6-6v48H32V38l-6 6-10-10z' },
      serum: { label: 'Serum', ghost: 'Skincare', name: 'Glow Serum 30 ml', price: 649, compare: 999, tag: 'Bestseller', variants: ['30 ml', '50 ml'], announce: 'Free shipping over ₹499  ✦  Cruelty-free  ✦  COD available', review: '"Skin feels so soft. Re-ordering!"', colour: '#FF7A90',
        icon: 'M41 8h18v12H41zM36 20h28v8H36zM32 28h36a6 6 0 0 1 6 6v52a8 8 0 0 1-8 8H34a8 8 0 0 1-8-8V34a6 6 0 0 1 6-6z' },
      buds: { label: 'Earbuds', ghost: 'Gadgets', name: 'Pro Buds ANC', price: 1999, compare: 3499, tag: 'Just launched', variants: ['Black', 'White', 'Sage'], announce: '1-year warranty  ✦  Ships in 24 hours  ✦  COD available', review: '"Bass is crazy for this price."', colour: '#5EE6A8',
        icon: 'M30 22a13 13 0 1 1 0 26a13 13 0 0 1 0-26zM26 46h8v30a4 4 0 0 1-8 0zM70 22a13 13 0 1 1 0 26a13 13 0 0 1 0-26zM66 46h8v30a4 4 0 0 1-8 0z' },
      lamp: { label: 'Lamp', ghost: 'Home decor', name: 'Sunset Lamp', price: 1299, compare: 1899, tag: 'Trending', variants: ['Warm', 'RGB'], announce: 'Ships in 24 hours  ✦  Easy returns  ✦  COD available', review: '"My room looks like a cafe now."', colour: '#FFB547',
        icon: 'M30 16h40l13 36H17zM47 52h6v28h-6zM30 80h40v8H30z' }
    };
    var COLOUR_NAMES = { '#9B8CFF': 'Violet', '#FF7A90': 'Coral', '#5EE6A8': 'Mint', '#FFB547': 'Marigold', '#4DA3FF': 'Sky' };
    var FEATURE_TEXT = { announce: 'Attention', trust: 'Trust', reviews: 'Desire', sticky: 'Action' };
    var state = { niche: 'tee', colour: '#9B8CFF', colourName: 'Violet', font: 'bold' };
    var rupee = function (n) { return '₹' + n.toLocaleString('en-IN'); };

    function inkFor(hex) {
      var h = hex.replace('#', '');
      var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
      return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#111' : '#fff';
    }
    function setColour(hex, name) {
      state.colour = hex;
      state.colourName = name || 'Custom';
      section.style.setProperty('--brand', hex);
      section.style.setProperty('--brand-ink', inkFor(hex));
      summary();
    }
    function summary() {
      $('#lab-summary').textContent = NICHES[state.niche].label + ' · ' + state.colourName + ' · ' + state.font.charAt(0).toUpperCase() + state.font.slice(1);
    }

    function fillNiche(n) {
      $('#lab-name').textContent = n.name;
      $('#lab-price').textContent = rupee(n.price);
      $('#lab-sticky-price').textContent = rupee(n.price);
      $('#lab-compare').textContent = rupee(n.compare);
      $('#lab-off').textContent = Math.round((1 - n.price / n.compare) * 100) + '% off';
      $('#lab-tag').textContent = n.tag;
      $('#lab-announce').textContent = n.announce;
      $('#lab-review').textContent = n.review;
      $('#lab-icon-path').setAttribute('d', n.icon);
      $('#lab-variants').innerHTML = n.variants.map(function (v, i) { return '<i class="' + (i === Math.min(1, n.variants.length - 1) ? 'is-on' : '') + '">' + v + '</i>'; }).join('');
    }
    function setNiche(key, animate) {
      state.niche = key;
      var n = NICHES[key];
      ghost.classList.add('is-swap');
      if (animate && !reduced) {
        phone.classList.remove('is-flip');
        void phone.offsetWidth;
        phone.classList.add('is-flip');
        setTimeout(function () { fillNiche(n); }, 340);
      } else fillNiche(n);
      setTimeout(function () { ghost.textContent = n.ghost; ghost.classList.remove('is-swap'); }, 300);
      // Each product comes with a sensible default colour, unless the visitor picked their own.
      if (!state.customColour) {
        var radio = $('input[name="lab-c"][value="' + n.colour + '"]');
        if (radio) radio.checked = true;
        setColour(n.colour, COLOUR_NAMES[n.colour]);
      }
      summary();
    }

    $$('input[name="lab-niche"]').forEach(function (r) { r.addEventListener('change', function () { setNiche(r.value, true); }); });
    $$('input[name="lab-c"]').forEach(function (r) {
      r.addEventListener('change', function () { state.customColour = true; setColour(r.value, COLOUR_NAMES[r.value]); });
    });
    $('#lab-custom').addEventListener('input', function (e) {
      state.customColour = true;
      $$('input[name="lab-c"]').forEach(function (r) { r.checked = false; });
      setColour(e.target.value.toUpperCase(), 'Custom');
    });
    $$('input[name="lab-f"]').forEach(function (r) {
      r.addEventListener('change', function () { state.font = r.value; phone.dataset.f = r.value; summary(); });
    });

    // Your name on the store, typed live.
    var nameInput = $('#lab-name-input');
    var logo = $('#lab-logo');
    var typingTimer = 0;
    nameInput.addEventListener('input', function () {
      var v = nameInput.value.trim();
      logo.textContent = v || 'yourstore';
      logo.parentNode.classList.add('is-typing');
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function () { logo.parentNode.classList.remove('is-typing'); }, 900);
    });

    // Conversion features: switch one off and that part leaves the store, with a warning.
    var warn = $('#lab-warn');
    var countEl = $('#lab-count');
    function features() {
      var boxes = $$('input[data-feature]');
      var on = 0;
      boxes.forEach(function (b) {
        var part = phone.querySelector('[data-part="' + b.dataset.feature + '"]');
        part.classList.toggle('is-off', !b.checked);
        if (b.checked) on++;
      });
      countEl.textContent = on + '/' + boxes.length + ' on';
      countEl.classList.toggle('is-low', on < boxes.length);
      return on;
    }
    $$('input[data-feature]').forEach(function (b) {
      b.addEventListener('change', function () {
        var on = features();
        var lever = FEATURE_TEXT[b.dataset.feature];
        var part = phone.querySelector('[data-part="' + b.dataset.feature + '"]');
        if (b.checked) {
          part.classList.remove('is-glow');
          void part.offsetWidth;
          part.classList.add('is-glow');
          warn.textContent = on === 4 ? 'Every conversion lever is on. This is the storefront you get.' : lever + ' is back on.';
          warn.classList.add('is-good');
        } else {
          warn.textContent = 'Lever off: ' + lever + '. This is where a basic store loses people.';
          warn.classList.remove('is-good');
        }
      });
    });

    // The add-to-cart inside the phone works.
    var addBtn = $('#lab-add');
    var cartBtn = $('#lab-cartbtn');
    var fly = $('#lab-fly');
    var cartN = 0;
    function addToCart() {
      addBtn.classList.add('is-press');
      setTimeout(function () { addBtn.classList.remove('is-press'); }, 160);
      addBtn.textContent = 'Added ✓';
      setTimeout(function () { addBtn.textContent = 'Add to cart'; }, 1100);
      var p = phone.getBoundingClientRect(), a = addBtn.getBoundingClientRect(), c = cartBtn.getBoundingClientRect();
      var from = { x: a.left - p.left + a.width / 2, y: a.top - p.top }, to = { x: c.left - p.left + c.width / 2, y: c.top - p.top + c.height / 2 };
      var done = function () {
        cartN++;
        $('#lab-cart').textContent = String(cartN);
        cartBtn.classList.add('has-item');
        cartBtn.classList.remove('is-bump');
        void cartBtn.offsetWidth;
        cartBtn.classList.add('is-bump');
      };
      if (reduced || !fly.animate) return done();
      fly.animate([
        { transform: 'translate(' + from.x + 'px,' + from.y + 'px) scale(1)', opacity: 1 },
        { transform: 'translate(' + (from.x + to.x) / 2 + 'px,' + (Math.min(from.y, to.y) - 60) + 'px) scale(1.3)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + to.x + 'px,' + to.y + 'px) scale(0.4)', opacity: 0.2 }
      ], { duration: 650, easing: 'cubic-bezier(0.45, 0, 0.2, 1)' }).onfinish = done;
    }
    addBtn.addEventListener('click', addToCart);
    $$('#lab-variants').forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var v = e.target.closest('i');
        if (!v) return;
        $$('i', wrap).forEach(function (i) { i.classList.toggle('is-on', i === v); });
      });
    });
    // The phone is decorative for assistive tech, so its controls stay pointer-only
    // extras; every choice is also available in the labelled controls beside it.

    // Drag to turn, spring back.
    var drag = null;
    tilt.addEventListener('pointerdown', function (e) {
      if (e.target.closest('#lab-add, #lab-variants')) return;
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId };
      tilt.classList.add('is-drag');
      tilt.classList.remove('is-spring');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) < Math.abs(dy) && e.pointerType === 'touch') return;
      tilt.style.setProperty('--ry', clamp(-14 + dx * 0.35, -60, 60) + 'deg');
      tilt.style.setProperty('--rx', clamp(-dy * 0.15, -18, 18) + 'deg');
    });
    function release(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      drag = null;
      tilt.classList.remove('is-drag');
      tilt.classList.add('is-spring');
      tilt.style.setProperty('--ry', '-14deg');
      tilt.style.setProperty('--rx', '0deg');
      setTimeout(function () { tilt.classList.remove('is-spring'); }, 900);
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    // Step tabs: one panel at a time, so the phone and every control fit in one frame.
    var tabs = $$('.lab__tabs [role="tab"]');
    var next = $('#lab-next');
    function selectTab(t, focus) {
      var i = tabs.indexOf(t);
      tabs.forEach(function (o) {
        var on = o === t;
        o.setAttribute('aria-selected', String(on));
        o.tabIndex = on ? 0 : -1;
        o.classList.toggle('is-done', tabs.indexOf(o) < i);
      });
      $$('.ctrl', section).forEach(function (c) { c.classList.toggle('is-active', c.dataset.panel === t.dataset.tab); });
      if (focus) t.focus();
      if (next) {
        var after = tabs[i + 1];
        next.hidden = !after;
        if (after) next.firstChild.nodeValue = 'Next: ' + after.textContent.replace(/^\d+/, '') + ' ';
      }
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { selectTab(t); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), to = null;
        if (e.key === 'ArrowRight') to = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') to = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') to = tabs[0];
        else if (e.key === 'End') to = tabs[tabs.length - 1];
        if (to) { e.preventDefault(); selectTab(to, true); }
      });
    });
    if (next) next.addEventListener('click', function () {
      var cur = tabs.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0];
      var after = tabs[tabs.indexOf(cur) + 1];
      if (after) selectTab(after, true);
    });

    setNiche('tee', false);
    features();
  })();

  /* ---------- buy dock: always on phones; on desktop once the hero button has scrolled away ---------- */
  (function () {
    var dock = $('#dock');
    var heroBuy = $('.lx-hero__buy');
    if (!dock) return;
    document.body.classList.add('has-dock');
    if (!heroBuy || !('IntersectionObserver' in window)) { dock.classList.add('is-past'); return; }
    new IntersectionObserver(function (e) {
      dock.classList.toggle('is-past', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(heroBuy);
    // Step aside while one of the page's own buy buttons is on screen: no double buttons, no overlap.
    var ownBuys = $$('.price-sec .btn--buy, .lx-final .btn--buy, .lx-hero__buy');
    var onScreen = new Set();
    var coverIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) onScreen.add(en.target); else onScreen.delete(en.target); });
      dock.classList.toggle('is-covered', onScreen.size > 0);
    }, { threshold: 0.5 });
    ownBuys.forEach(function (b) { coverIO.observe(b); });
  })();

  /* ---------- one-shot reveals ---------- */
  var once = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.id === 'onepct') lightGrid();
      once.unobserve(e.target);
    });
  }, { threshold: 0.35 });
  $$('.obsess, .price-roll, .handoff').forEach(function (el) { once.observe(el); });

  // The kit box: closed and floating, shakes, bursts open, then everything inside flies out.
  var offerSec = $('#offer');
  var kit = $('#kitbox');
  var boxTimer = 0;
  function openBox() {
    clearTimeout(boxTimer);
    if (reduced) { kit.classList.add('is-open'); offerSec.classList.add('is-open'); return; }
    kit.classList.remove('is-open');
    offerSec.classList.remove('is-open');
    kit.classList.add('is-shake');
    boxTimer = setTimeout(function () {
      kit.classList.remove('is-shake');
      kit.classList.add('is-open');
      offerSec.classList.add('is-open');
    }, 750);
  }
  new IntersectionObserver(function (e) {
    if (e[0].isIntersecting && !kit.classList.contains('is-open') && !kit.classList.contains('is-shake')) openBox();
  }, { threshold: 0.6 }).observe(kit);
  // On phones the cards can scroll into view before the box does: open it then too.
  new IntersectionObserver(function (e) {
    if (e[0].isIntersecting && !kit.classList.contains('is-open') && !kit.classList.contains('is-shake')) openBox();
  }, { threshold: 0.15 }).observe($('.pillars', offerSec));
  kit.addEventListener('click', function () {
    kit.classList.remove('is-open');
    offerSec.classList.remove('is-open');
    boxTimer = setTimeout(openBox, 450);
  });

  // 1%: a hundred dots fill in, then exactly one turns gold.
  var grid = $('#onepct');
  for (var gi = 0; gi < 100; gi++) grid.appendChild(document.createElement('i'));
  once.observe(grid);
  function lightGrid() {
    var dots = $$('i', grid);
    if (reduced) { dots.forEach(function (d) { d.classList.add('is-lit'); }); dots[54].classList.add('is-one'); return; }
    dots.forEach(function (d, i) { setTimeout(function () { d.classList.add('is-lit'); }, i * 12); });
    setTimeout(function () { dots[54].classList.add('is-one'); }, 1500);
  }

  // Final: the same traffic, now caught.
  var finalOrders = $('#final-orders');
  var finalTimer = null;
  new IntersectionObserver(function (e) {
    if (e[0].isIntersecting && !finalTimer && !reduced) {
      addOrder(finalOrders);
      finalTimer = setInterval(function () { addOrder(finalOrders); }, 1700);
    } else if (!e[0].isIntersecting && finalTimer) { clearInterval(finalTimer); finalTimer = null; }
  }).observe($('#final'));


  /* ---------- highlighted words in headings: a marker sweeps across ---------- */
  $$('mark.hl').forEach(function (el) { once.observe(el); });

  /* ---------- impact: before/after compare with both live stores ---------- */
  (function () {
    var cmp = $('#compare');
    if (!cmp) return;
    var range = $('.compare__range', cmp);
    var screen = $('.compare__screen', cmp);
    var cb = $('#cmp-before'), ca = $('#cmp-after');
    var touched = false, dragging = false, visible = false, looping = false, screens = null, requested = false;
    var t0 = performance.now(), lastDraw = 0, lastPing = 0;
    function set(v) { cmp.style.setProperty('--x', v.toFixed(2) + '%'); }
    function touch() { touched = true; cmp.classList.add('is-touched'); }
    range.addEventListener('input', function () { touch(); set(+range.value); });
    function fromEvent(e) {
      var r = screen.getBoundingClientRect();
      var v = clamp((e.clientX - r.left) / r.width, 0.03, 0.97) * 100;
      range.value = v;
      set(v);
    }
    screen.addEventListener('pointerdown', function (e) {
      dragging = true;
      touch();
      cmp.classList.add('is-drag');
      if (screen.setPointerCapture) screen.setPointerCapture(e.pointerId);
      fromEvent(e);
    });
    screen.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) {
      screen.addEventListener(n, function () { dragging = false; cmp.classList.remove('is-drag'); });
    });
    function loop(now) {
      if (!visible) { looping = false; return; }
      var t = (now - t0) / 1000;
      if (!touched && !reduced) {
        var v = 50 + Math.sin(t * 0.8) * 30;
        range.value = v;
        set(v);
      }
      // 20fps is plenty for two small screens and halves their paint cost while the page scrolls.
      if (screens && now - lastDraw > 50) {
        screens.tick((now - lastDraw) / 1000);
        lastDraw = now;
        if (!reduced && now - lastPing > 4200) { lastPing = now; screens.ping(); }
        cb.getContext('2d').drawImage(screens.compose('basic', t, reduced), 0, 0);
        ca.getContext('2d').drawImage(screens.compose('brand', t, reduced), 0, 0);
      }
      requestAnimationFrame(loop);
    }
    function load() {
      if (requested) return;
      requested = true;
      loadScript(document.body.dataset.lxScreens, 'LaunchScreens').then(function (m) {
        return m.liveScreens({});
      }).then(function (s) {
        screens = s;
        cmp.classList.add('is-live');
      }).catch(function (e) { console.error('screens', e); });
    }
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) load();
    }, { rootMargin: '600px 0px' }).observe(cmp);
    new IntersectionObserver(function (e) {
      visible = e[0].isIntersecting;
      if (visible && !looping) { looping = true; requestAnimationFrame(loop); }
    }).observe(cmp);
  })();

  /* ---------- reviews: an endless rail that pauses under a finger or the mouse ---------- */
  $$('[data-marquee]').forEach(function (rail) {
    var track = rail.firstElementChild;
    if (!track || reduced || track.children.length < 2) return;
    Array.prototype.slice.call(track.children).forEach(function (li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      track.appendChild(c);
    });
    rail.classList.add('is-running');
  });

  /* ---------- vault on phones: open once in view, then count up ---------- */
  (function () {
    var v = $('#vault');
    if (!v) return;
    function countUp() {
      $$('[data-count]', v).forEach(function (el, i) {
        var n = +el.dataset.count;
        if (reduced) { el.textContent = n.toLocaleString('en-IN'); return; }
        var start = performance.now() + 1900 + i * 150;
        (function tick() {
          var k = clamp((performance.now() - start) / 1100);
          el.textContent = Math.round(n * (1 - Math.pow(1 - k, 3))).toLocaleString('en-IN');
          if (k < 1) setTimeout(tick, 33);
        })();
      });
    }
    new IntersectionObserver(function (e, io) {
      if (!e[0].isIntersecting || wide()) return;
      v.classList.add('is-open');
      countUp();
      io.disconnect();
    }, { threshold: 0.25 }).observe($('.vault__room', v));
  })();

  /* ---------- footer: the wordmark lights up under the pointer ---------- */
  (function () {
    var word = $('#ft-word');
    if (!word || !fine || reduced) return;
    word.addEventListener('pointermove', function (e) {
      var r = word.getBoundingClientRect();
      word.classList.add('is-pointer');
      word.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      word.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
    word.addEventListener('pointerleave', function () { word.classList.remove('is-pointer'); });
  })();

  /* ---------- scroll choreography ---------- */
  var nav = $('.nav');
  var bar = $('.progress');
  var rebuild = $('#rebuild');
  var steps = $$('.steps li');
  var qa = $$('.qa__row');
  var priceBig = $('.price-big b');
  var rises = $$('[data-rise]');
  var needs = $('#needs');
  var handles = $$('#handles li');
  var needEnds = [];
  (function () {
    var words = needs ? $$('.w', needs) : [];
    words.forEach(function (w, i) { if (/\.$/.test(w.textContent)) needEnds.push(i + 1); });
  })();
  var vault = $('#vault');
  var vaultCounts = vault ? $$('[data-count]', vault).map(function (el) { return { el: el, n: +el.dataset.count, item: el.closest('.vitem') }; }) : [];
  var vaultItems = vault ? $$('.vitem', vault) : [];
  var needRows = $$('.need');
  var integ = $('#integ');
  var integBeam = $('#integ-beam');
  var integWin = integ ? $('.integ__win', integ) : null;
  var integWire = integBeam ? $('.integ__wire', integBeam) : null;
  var integFlow = integBeam ? $('.integ__flow', integBeam) : null;
  var integSpark = integBeam ? $('.integ__spark', integBeam) : null;
  var rebuildSlot = $('#rebuild-slot');
  var INSTALL = 0.24;
  var ticking = false;
  var settledStatic = false;
  var NOREC = { top: 0, height: 0 };
  var NOLIST = [];
  var lastY = window.scrollY;

  // Write only what changed. A style, class or text write marks the layout dirty, and the next
  // frame's measuring (here and in the 3D stage) then pays for a full relayout of the page.
  var written = new WeakMap();
  function put(el, prop, val) {
    var m = written.get(el);
    if (!m) { m = {}; written.set(el, m); }
    if (m[prop] === val) return;
    m[prop] = val;
    el.style.setProperty(prop, val);
  }
  function tog(el, cls, on) {
    on = !!on;
    if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
  }
  function text(el, val) { if (el.textContent !== val) el.textContent = val; }

  function progress(el) {
    var r = el.getBoundingClientRect();
    return clamp(-r.top / Math.max(r.height - viewH, 1));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function update() {
    ticking = false;
    var H = viewH;
    var y = window.scrollY;

    // Measure everything first, then write. Interleaving reads with style writes forced a fresh
    // layout per element per frame, which is what made touch scrolling stutter.
    var scrollMax = Math.max(document.documentElement.scrollHeight - H, 1);
    // Lighter mode: every scene shows its final state, so nothing is measured, and once those states are
    // applied a scroll only has to move the progress bar and the nav.
    if (reduced && settledStatic) { put(bar, '--p', (y / scrollMax).toFixed(4)); navWork(y); return; }
    var rbr = reduced ? NOREC : rebuild.getBoundingClientRect();
    var needTops = reduced ? NOLIST : needRows.map(function (row) { return row.getBoundingClientRect().top; });
    var qaTops = reduced ? NOLIST : qa.map(function (row) { return row.getBoundingClientRect().top; });
    var priceTop = reduced ? 0 : priceBig.getBoundingClientRect().top;
    var riseTops = reduced ? NOLIST : rises.map(function (el) { return el.getBoundingClientRect().top; });
    var litRects = reduced ? NOLIST : lits.map(function (L) { return L.el.getBoundingClientRect(); });
    var vaultRect = vault && wide() ? (reduced ? NOREC : vault.getBoundingClientRect()) : null;

    put(bar, '--p', (y / scrollMax).toFixed(4));

    // Reveal: one progress value drives the phone, the colour shift, the ghost word, the callouts.
    // The first part of the reveal installs the add-on into Shopify; the rebuild plays after it.
    var rAll = reduced ? 1 : clamp(-rbr.top / Math.max(rbr.height - H, 1));
    var ig = clamp(rAll / INSTALL);
    var r = clamp((rAll - INSTALL) / (1 - INSTALL));
    if (integ) {
      put(integ, '--ig-in', seg(ig, 0, 0.18).toFixed(4));
      put(integ, '--ig-file', seg(ig, 0.12, 0.42).toFixed(4));
      put(integ, '--ig-up', clamp((ig - 0.42) / 0.22).toFixed(4));
      put(integ, '--ig-pub', seg(ig, 0.66, 0.78).toFixed(4));
      put(integ, '--ig-beam', seg(ig, 0.74, 0.96).toFixed(4));
      put(integ, '--ig-out', seg(rAll, INSTALL + 0.02, INSTALL + 0.12).toFixed(4));
      tog(integ, 'is-installed', ig >= 0.64);
      tog(integ, 'is-live', ig >= 0.96);
      tog(integ, 'is-gone', rAll > INSTALL + 0.13);
      tog(root, 'is-installing', !wide() && !reduced && rbr.top < H && rbr.bottom > 0 && ig < 0.8);
      if (wide() && integWin && rebuildSlot && integWire && ig > 0.6 && rAll < INSTALL + 0.13) {
        var ir = integ.getBoundingClientRect();
        var wr = integWin.getBoundingClientRect();
        var pr = rebuildSlot.getBoundingClientRect();
        var x0, y0, x1, y1, d;
        x0 = wr.left - ir.left; y0 = wr.top + wr.height * 0.55 - ir.top;
        x1 = pr.left + pr.width * 0.86 - ir.left; y1 = pr.top + pr.height * 0.5 - ir.top;
        d = 'M' + x0 + ' ' + y0 + ' C' + (x0 + (x1 - x0) * 0.5) + ' ' + y0 + ' ' + (x0 + (x1 - x0) * 0.5) + ' ' + y1 + ' ' + x1 + ' ' + y1;
        integWire.setAttribute('d', d);
        integFlow.setAttribute('d', d);
        var len = integWire.getTotalLength ? integWire.getTotalLength() : 600;
        var bk = clamp((ig - 0.74) / 0.22);
        integWire.style.strokeDasharray = len;
        integWire.style.strokeDashoffset = (len * (1 - bk)).toFixed(1);
        if (integWire.getPointAtLength) {
          var pt = integWire.getPointAtLength(len * bk);
          integSpark.setAttribute('cx', pt.x.toFixed(1));
          integSpark.setAttribute('cy', pt.y.toFixed(1));
        }
      }
    }
    put(rebuild, '--r', r.toFixed(4));
    put(rebuild, '--brand', seg(r, 0.5, 0.85).toFixed(4));
    if (stage) stage.setRebuild(r);
    var step = rAll < INSTALL ? 0 : r < 0.15 ? 1 : r < 0.36 ? 2 : r < 0.74 ? 3 : 4;
    steps.forEach(function (s, i) { tog(s, 'is-active', i === step); });
    callouts.forEach(function (c, i) {
      tog(c, 'is-on', r > 0.18 + i * 0.025 && r < 0.86);
      tog(c, 'is-fixed', r > 0.43 + i * 0.07);
    });

    // Each need ticks off as it reaches the middle of the screen.
    needRows.forEach(function (row, i) { tog(row, 'is-on', reduced || needTops[i] < H * 0.7); });

    // Excuses get crossed out one by one as they pass the middle of the screen.
    qa.forEach(function (row, i) { tog(row, 'is-on', reduced || qaTops[i] < H * 0.62); });

    // The price grows as it arrives.
    put(priceBig, '--pz', (reduced ? 1 : 0.7 + 0.3 * seg(1 - (priceTop - H * 0.3) / H, 0, 1)).toFixed(3));

    // Light sections rise in like cards.
    rises.forEach(function (el, i) {
      put(el, '--rise', reduced ? '1' : seg(1 - riseTops[i] / H, 0, 0.6).toFixed(4));
    });

    // Word-lit paragraphs fill in as you read.
    // Only the words between the last count and this one change, so only those are touched.
    var litInNeeds = 0;
    lits.forEach(function (L, li) {
      var lr = litRects[li];
      var lp2 = reduced ? 1 : clamp((H * 0.78 - lr.top) / (lr.height + H * 0.3));
      var n = Math.round(lp2 * L.words.length);
      var was = L.n === undefined ? -1 : L.n;
      if (n !== was) {
        var lo = was < 0 ? 0 : Math.min(n, was), hi = was < 0 ? L.words.length : Math.max(n, was);
        for (var i = lo; i < hi; i++) tog(L.words[i], 'is-lit', i < n);
        L.n = n;
      }
      if (needs && needs.contains(L.el)) litInNeeds += n;
    });

    // Each need that lights up ticks off the matching Ecomlab feature.
    if (needs) {
      handles.forEach(function (li, i) { tog(li, 'is-on', reduced || litInNeeds >= needEnds[i]); });
    }

    // Vault: dial spins, bolts slide back, the door swings open, the extras come out.
    if (vaultRect) {
      var vp = reduced ? 1 : clamp(-vaultRect.top / Math.max(vaultRect.height - H, 1));
      put(vault, '--dial', seg(vp, 0, 0.26).toFixed(4));
      put(vault, '--bolt', seg(vp, 0.14, 0.3).toFixed(4));
      put(vault, '--door', seg(vp, 0.28, 0.55).toFixed(4));
      put(vault, '--glow', seg(vp, 0.36, 0.6).toFixed(4));
      vaultItems.forEach(function (it, i) { put(it, '--it', seg(vp, 0.48 + i * 0.09, 0.66 + i * 0.09).toFixed(4)); });
      var total = seg(vp, 0.62, 0.9);
      put(vault, '--total', total.toFixed(4));
      vaultCounts.forEach(function (c) {
        var k = c.item ? seg(vp, 0.48 + vaultItems.indexOf(c.item) * 0.09, 0.7 + vaultItems.indexOf(c.item) * 0.09) : total;
        text(c.el, Math.round(c.n * k).toLocaleString('en-IN'));
      });
    }

    navWork(y);
    if (reduced) settledStatic = true;
  }

  function navWork(y) {
    tog(nav, 'is-scrolled', y > 30);

    // Phones: the bar slides away while reading down and returns on the first scroll up.
    if (wide() || y < 120) tog(nav, 'is-hidden', false);
    else if (y > lastY + 6) tog(nav, 'is-hidden', true);
    else if (y < lastY - 6) tog(nav, 'is-hidden', false);
    if (Math.abs(y - lastY) > 6) lastY = y;
  }

  // Nav reads the section underneath it: light sections crossing a thin band at the top of the screen.
  // An observer does this off the scroll path; a per-frame hit test forced layout on every frame.
  if ('IntersectionObserver' in window) {
    var underNav = new Set();
    var navBand = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) underNav.add(e.target); else underNav.delete(e.target); });
      nav.classList.toggle('nav--on-light', underNav.size > 0);
    }, { rootMargin: '-30px 0px -92% 0px' });
    $$('.lx-problem, .excuses, .founder').forEach(function (s) { navBand.observe(s); });
  }

  // Sections far off screen pause their looping CSS animations: marquees, sheens, pulses and floors
  // otherwise restyle, repaint and re-layer every frame for content nobody can see.
  if ('IntersectionObserver' in window) {
    var idle = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-idle', !e.isIntersecting); });
    }, { rootMargin: '300px 0px' });
    $$('main > .shopify-section, .ft').forEach(function (s) { idle.observe(s); });
  }

  /* ---------- weak-device governor ----------
     <head> decides from hard signals (low memory, few cores, data saver, 2G). This watches REAL frame times:
     a few seconds after load, and during the first scroll. If the device is clearly struggling it remembers
     that for a week and switches to the lighter mode (reload only while still near the top). Strong phones
     and laptops never trip it. ?lite=0 forces the full mode, ?lite=1 the lighter one. */
  if (!reduced && !window.__lxLiteForced) {
    var govDone = false;
    var govMedian = function (a) { var b = a.slice().sort(function (x, y) { return x - y; }); return b[Math.floor(b.length / 2)]; };
    var govTrip = function (why) {
      if (govDone) return;
      govDone = true;
      try { localStorage.setItem('lx-lite', '1|' + Date.now()); } catch (e) {}
      root.dataset.lxLite = why;
      if (window.scrollY < 2500) {
        try {
          if (sessionStorage.getItem('lx-lite-reloaded')) return;
          sessionStorage.setItem('lx-lite-reloaded', '1');
        } catch (e) { return; }
        location.reload();
      }
    };
    // 1) idle frames, 3.5s to 6s after load (the hero is animating, nothing else is going on)
    var idleFrames = [], idleLast = 0, idleFrom = performance.now() + 3500, idleTo = idleFrom + 2500;
    var idleTick = function (now) {
      if (govDone) return;
      if (now >= idleFrom && idleLast && !document.hidden) idleFrames.push(now - idleLast);
      idleLast = document.hidden ? 0 : now;
      if (now > idleTo) { if (idleFrames.length > 25 && govMedian(idleFrames) > 40) govTrip('idle'); return; }
      requestAnimationFrame(idleTick);
    };
    requestAnimationFrame(idleTick);
    // 2) the first scroll, 1.6s of it
    var scrollFrames = [], scrollLast = 0, scrollStart = 0;
    var scrollTick = function (now) {
      if (govDone) return;
      if (scrollLast) scrollFrames.push(now - scrollLast);
      scrollLast = now;
      if (now - scrollStart > 1600) { if (scrollFrames.length > 12 && govMedian(scrollFrames) > 45) govTrip('scroll'); return; }
      requestAnimationFrame(scrollTick);
    };
    window.addEventListener('scroll', function firstScroll() {
      window.removeEventListener('scroll', firstScroll);
      scrollStart = performance.now();
      requestAnimationFrame(scrollTick);
    }, { passive: true });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
